import TFieldMask from './TFieldMask';

export default TFieldMask;
